export default "__VITE_ASSET__DC_bYWga__"